<template>
  <div class="hawkEyePlayBack">
    <el-card>
      <el-button type="primary" slot="header" @click="back()">返回上一级</el-button>
      <div style="margin:0 0 20px 50px">
        <div id="video-container"></div>
      </div>

    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:hawkEyeOfParkList
   *@Description:园区鹰眼 监控
   *@author:刘彦辰
   *@Copyright:格众科技
   *@date:2020-05-8
   */
  import EZUIKit from 'ezuikit-js'
  import {
    mapGetters
  } from 'vuex'
  var player
  export default {
    name: '/manage/main.supplyVideoPb',
    data() {
      return {
        accessToken: '', // 萤石accessToken
        pbYsNumber: '', // 回放ysNumber
        pbTdNumber: '', // 回放TdNumber
        pbVideoURL: '', // 回放地址
        state: '',
      }
    },
    created() {
      this.pbYsNumber = this.$route.query.pbYsNumber
      this.pbTdNumber = this.$route.query.pbTdNumber
      this.state = this.$route.query.state
      // this.pbVideoURL = 'ezopen://open.ys7.com/L06575750/1.hd.live'
      this.pbVideoURL = 'ezopen://open.ys7.com/' + this.pbYsNumber + '/' + this.pbTdNumber + '.hd.live'
      let that = this
      setTimeout(function() {
        that.getLiftToken()
      }, 100)
    },
    mounted() {

    },
    beforeDestroy() {
      player.stop()
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    watch: {

    },
    methods: {
      // 返回上一级
      back() {
        player.stop()
        this.$router.push({
          name: 'hawkEyeOfParkList',
        })
      },
      // 获取萤石token
      getLiftToken() {
        let loading = this.$loading()
        this.$get(`aapi/getLiftToken`)
          .then(res => {
              loading.close()
              console.log(res)
              this.accessToken = res.accessToken
              this.initVideo()
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
      },
      // 初始化视频
      initVideo() {
        player = new EZUIKit.EZUIKitPlayer({
          id: 'video-container', // 视频容器ID
          accessToken: this.accessToken,
          url: this.pbVideoURL,
          template: this.state == 'playBack' ? 'pcRec' : 'pcLive',
          width: 1000,
          height: 600,
          footer: ['fullScreen']
        })
        player.play()
      },
    }
  }
</script>

<style lang="scss">
  .hawkEyePlayBack {
    #video-container {
      height: 85%;
    }
  }
</style>